// Nút ở chân thanh bên dẫn tới chỗ nối Telegram.
//
// Trước 17/10/2026 nút này xin quyền thông báo của TRÌNH DUYỆT rồi hiện "Đã bật
// thông báo ✅" — nhưng web ERP chưa từng đăng ký thiết bị với máy chủ (phần đó
// của bản cũ chưa chuyển sang), nên không tin đẩy nào tới cả: nhân sự tưởng đã
// bật mà không nhận gì (soát thông báo 17/10/2026, CEO chốt 4a). Kênh tới điện
// thoại đang chạy thật là Telegram — nút dẫn thẳng tới thẻ "Nhận tin qua
// Telegram" ở trang "Của tôi".
import { Link } from "@tanstack/react-router";
import { Bell } from "lucide-react";

export function EnableNotificationButton() {
  return (
    <Link
      to="/me"
      className="flex w-full items-center justify-center gap-2 rounded-lg border border-amber-600 bg-amber-50 px-4 py-2 text-sm font-medium text-amber-900 hover:bg-amber-100"
    >
      <Bell size={16} /> Nhận tin qua Telegram
    </Link>
  );
}
